import React, { Suspense, useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Tracking from './pages/Tracking';
import './assets/styles/main.scss';
import { CommonContextProvider } from './context/CommonContext';
import Orders from './components/orders';
import CreateOrder from './components/orders/createOrder';
import Ordersb2b from './components/ordersb2b';
import CreateOrderb2b from './components/ordersb2b/createOrderb2b';
import Merchants from './components/merchants';
import Couriers from './components/couriers';
import Branches from './components/branches';
import Warehouse from './components/warehouse';
import Brands from './components/brands';
import Category from './components/category';
import SubCategory from './components/subcategory';

import Recharge from './components/recharge';
import Freight from './components/freight';
import Freightb2b from './components/freightb2b';
import Ndr from './components/ndr';
import Ndrb2b from './components/ndrb2b';
import Users from './components/users';
import Weight from './components/weight';
import Weightb2b from './components/weightb2b';
import Serviceability from './components/serviceability';
import Trackings from './components/trackings';
import PickupRequests from './components/pickupRequests';
import SignupMerchants from './components/signupMerchants';
import Invoices from './components/invoices';
import Invoicesb2b from './components/invoicesb2b';
import CreditNote from './components/creditNote';
import Remittance from './components/remittance';
import Ivr from './components/ivr';
import PriceCalculator from './components/priceCalculator';
import Dashboard from './components/dashboard';
import ScanStatus from './components/scanStatus';
import CryptoJS from 'crypto-js';
import Downloads from './components/downloads';


const AdminSignIn = React.lazy(() => import('./components/common/AdminSignIn'));
const MerchantSignIn = React.lazy(() => import('./components/common/MerchantSignIn'));
const MerchantSignUp = React.lazy(() => import('./components/common/MerchantSignUp'));
const ForgotPassword = React.lazy(() => import('./components/common/ForgotPassword'));

const decryptData = (encryptedData, secretKey) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

const secretKey = 'user-login-key';



function App() {
  let location = useLocation();
  const storedUserData = localStorage.getItem('userInfo');
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userPermission, setUserPermission] = useState(null);
  useEffect(() => {
    if (storedUserData) {
      const parsedUser = decryptData(storedUserData, secretKey);
      // setUser(user);
      if (parsedUser?.permissions) {
        setUserPermission(JSON.parse(parsedUser?.permissions))
      }
      setUser(parsedUser);
      if (parsedUser?.permissions) {
        setUserPermission(JSON.parse(parsedUser?.permissions))
      }
      setUser(parsedUser);
    }
  }, [storedUserData]);
  return (
    <CommonContextProvider>
      <Layout>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route exact path="/admin" element={<AdminSignIn />} />
            <Route exact path="/login" element={<MerchantSignIn />} />
            <Route exact path="/signup" element={<MerchantSignUp />} />
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
            {user && (
              <>
                <Route path='*' element={<div>404</div>} />

                {user?.user_type !== "Merchant" ? (
                  <>
                    <Route path="/merchants/registered" element={<Merchants />} />
                    <Route path="/merchants/signup" element={<SignupMerchants />} />
                    <Route path="/couriers" element={<Couriers />} />
                    <Route path="/branches" element={<Branches />} />
                    <Route path="/ivr" element={<Ivr />} />
                    <Route path="/scan-status" element={<ScanStatus />} />
                    <Route path="/users" element={<Users />} />
                  </>
                ) : (
                  <></>
                )}
                <Route path="/" element={<Dashboard />} />
                <Route path="/orders/b2c" element={<Orders />} />
                <Route path="/orders/b2b" element={<Ordersb2b />} />
                <Route path="/orders/create-b2c" element={<CreateOrder />} />
                <Route path="/orders/create-b2b" element={<CreateOrderb2b />} />
                <Route path="/tracking" element={<Tracking />} />
                <Route path="/warehouse/list" element={<Warehouse />} />
                <Route path="/warehouse/brands" element={<Brands />} />
                <Route path="/warehouse/category" element={<Category />} />
                <Route path="/warehouse/subcategory" element={<SubCategory />} />

                <Route path="/recharge" element={<Recharge />} />
                <Route path="/freight/b2c" element={<Freight />} />
                <Route path="/freight/b2b" element={<Freightb2b />} />
                <Route path="/ndr/b2c" element={<Ndr />} />
                <Route path="/ndr/b2b" element={<Ndrb2b />} />
                <Route path="/weight/b2c" element={<Weight />} />
                <Route path="/weight/b2b" element={<Weightb2b />} />
                <Route path="/serviceability" element={<Serviceability />} />
                <Route path="/trackings" element={<Trackings />} />
                <Route path="/pickup-requests" element={<PickupRequests />} />
                <Route path="/invoices/b2c" element={<Invoices />} />
                <Route path="/invoices/b2b" element={<Invoicesb2b />} />
                <Route path="/credit-notes" element={<CreditNote />} />
                <Route path="/remittance" element={<Remittance />} />
                <Route path="/price-calculator" element={<PriceCalculator />} />
                <Route path="/download" element={<Downloads />} />
              </>
            )}
          </Routes>
        </Suspense>
      </Layout>
    </CommonContextProvider>
  );
}

export default App;
